<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Treść',
              modelPath: [this, 'form', 'content'],
              multilingual: true
            }),
            new fields.Switch({
              label: 'Pełna szerokość treści',
              modelPath: [this, 'form', 'content_has_full_width']
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true,
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Źródło',
              modelPath: [this, 'form', 'source'],
              multilingual: true
            }),
            new fields.Switch({
              label: 'Zdjęcie na całą szerokość',
              modelPath: [this, 'form', 'is_image_fluid'],
              disabled: get(this, ['form', 'is_reversed'])
            }),
            new fields.Switch({
              label: 'Zdjęcie po lewej',
              modelPath: [this, 'form', 'is_reversed'],
              disabled: get(this, ['form', 'is_image_fluid'])
            })
          ]
        }
      ]
    }
  }
}
</script>
